import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Sponsors from '../components/Sponsors';
import MenuAntioquia from '../components/MenuAntioquia';
import MenuItineraryAntioquia from '../components/MenuItineraryAntioquia';
import '../assets/styles/containers/SimpleSection.sass';

class SimpleSectionAntioquia extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
    }
  }
  
  componentDidMount() {
    const {slug} = this.props.match.params;
    this.getData(slug);
  }

  componentWillReceiveProps(nextProps) {
    const {slug} = this.props.match.params;
    if(slug !== nextProps.match.params.slug) {
      this.getData(nextProps.match.params.slug);
    }
 }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/general/antioquia-mtb/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({data: res});
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }
    
  render() {
    const {data} = this.state;
    const {content, sponsors} = data;

    return (
      <Layout>
        <>
          <Banner id={64} city="antioquia" thumb="logo_adventures.png"/>
          <MenuAntioquia />
          {this.props.itinerary &&
            <MenuItineraryAntioquia />
          }
          <div className="row content-min-height itinerary --antioquia">
            {ReactHtmlParser(content?.content_es)}
          </div>
          {sponsors && (
            <Sponsors
              items={sponsors}
              city="antioquia"
            />
          )}
        </>
      </Layout>
    );

  }
}

export default SimpleSectionAntioquia;
